@if (hasRenderableData()) {
  @if (showLegend() && (graph().series.length > 1 || showFirstObservedLegend())) {
    <div class="chart-legend" role="group" [attr.aria-label]="graph().title + ' series'">
      @for (series of coloredSeries(); track $index) {
        @if (graph().series.length > 1) {
        <button [attr.aria-pressed]="selectedSeries().has($index)"
          [class.chart-legend__entry--dimmed]="selectedSeries().size > 0 && !selectedSeries().has($index)"
          [title]="series.name" (click)="toggleSeries($index)" type="button" class="chart-legend__entry">
          <span [style.background-color]="series.color" class="chart-legend__swatch" aria-hidden="true"></span>
          <span>{{ series.name }}</span>
        </button>
        } @else {
          <span class="chart-legend__entry chart-legend__entry--label">
            <span [style.background-color]="series.color" class="chart-legend__swatch" aria-hidden="true"></span>
            <span>{{ series.name }}</span>
          </span>
        }
      }
      @if (showFirstObservedLegend()) {
        <span class="chart-legend__entry chart-legend__entry--label">
          <span class="chart-legend__swatch chart-legend__swatch--reference" aria-hidden="true"></span>
          <span>First observed</span>
        </span>
      }
      @if (selectedSeries().size > 0) {
        <button (click)="clearSeriesSelection()" type="button" class="iopoc-button small primary chart-legend__reset">
          Reset chart
        </button>
      }
    </div>
  }
  <div class="chart-container" [style.height]="height()">
    <canvas
      [type]="chartViewModel().type"
      [data]="chartViewModel().data"
      [options]="chartViewModel().options"
      [plugins]="chartPlugins"
      [attr.tabindex]="chartViewModel().type === 'line' ? 0 : null"
      [attr.aria-label]="graph().title + (chartViewModel().type === 'line' ? '. Use Left and Right arrows to inspect recorded values, Home and End to jump, and Escape to clear.' : '')"
      (keydown)="onChartKeydown($event)"
      (blur)="clearScrub()"
      baseChart>
    </canvas>
    @if (tooltip(); as currentTooltip) {
      <div #chartTooltip
        [style.left.px]="tooltipPosition().left" [style.top.px]="tooltipPosition().top"
        class="chart-tooltip" role="tooltip">
        @if (currentTooltip.title) {
          <div class="chart-tooltip__title">{{ currentTooltip.title }}</div>
        }
        @for (entry of currentTooltip.entries; track $index) {
          <div class="chart-tooltip__entry">
            @if (entry.wellCode && entry.measurementLabel) {
              <svg class="chart-tooltip__line" viewBox="0 0 40 12" aria-hidden="true">
                <line x1="0" x2="40" y1="6" y2="6" [attr.stroke]="entry.color"
                  stroke-width="3" [attr.stroke-dasharray]="entry.borderDash?.join(' ')" />
              </svg>
            } @else {
              <span [style.background-color]="entry.color" class="chart-tooltip__swatch" aria-hidden="true"></span>
            }
            <div class="chart-tooltip__reading">
              @if (entry.wellCode && entry.measurementLabel) {
                <div><strong>{{ entry.wellCode }}</strong> &middot; {{ entry.measurementLabel }} &middot; {{ entry.value }}</div>
              } @else if (currentTooltip.showNames) {
                <div><strong>{{ entry.name }}</strong>: {{ entry.value }}</div>
              } @else {
                <div><span class="visually-hidden">{{ entry.name }}: </span>{{ entry.value }}</div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
  @if (firstObservedLabel(); as label) {
    <p class="chart-reference">{{ label }}</p>
  }
  @if (highlightAfterFirstObserved()) {
    <p class="chart-reference">Yellow shading: from First observed to the end of the displayed chart; it does not indicate recovery.</p>
  }
  @if (eventPeriod(); as period) {
    <p class="chart-reference">
      {{ highlightAfterFirstObserved() ? 'Overall transient:' : 'Amber shading: overall transient,' }} {{ formatTimeValueForPeriod(period.onset) }} –
      {{ formatTimeValueForPeriod(period.transientEnd) }} WAT.
      {{ period.endUncertain ? 'End uncertain: not all channels have observed settling.' : 'Through latest sampled settling; not recovery.' }}
      @if (onsetUncertainty()) {
        Light gray shading: onset uncertainty, {{ formatTimeValueForPeriod(period.onsetNotBefore) }} –
        {{ formatTimeValueForPeriod(period.onset) }} WAT.
      } @else {
        Gray interval unavailable: no valid onset-uncertainty bracket was supplied.
      }
      Trace filtering does not change this period.
    </p>
  } @else if (highlightAfterFirstObserved()) {
    <p class="chart-reference">Gray interval unavailable: no onset-uncertainty bracket was supplied.</p>
  }
  <span class="chart-announcement" role="status" aria-live="polite">{{ scrubAnnouncement() }}</span>
}
